import { redirect } from "react-router-dom"
import { Links } from "../constants"
import { signInPageLink } from "../links"

export async function loadAppContext({ request }) {
  const url = new URL(request.url)
  if (request.url.includes(Links.signInPagePath) || request.url.includes(Links.ExternalSharePostPagePathPrefix) || request.url.includes(Links.PublicCampaignPagePathPrefix)) {
    return {}
  }
  const orgID = url.searchParams.get('orgID')
  const superUserQueryParams = new URLSearchParams()
  if (orgID) {
    superUserQueryParams.append("orgID", orgID)
  }

  const isInternalRedirect = url.searchParams.get("from") === "root"

  let res = await fetch(`/api/app-context?${superUserQueryParams.toString()}`)

  if (res.status === 401 && request.url.includes(Links.errorPagePath)) {
    return {}
  }

  if (res.status === 401 && !request.url.includes(Links.signInPagePath)) {
    let redirectUrl = encodeURIComponent(url.pathname + url.search)
    if (isInternalRedirect) {
      redirectUrl = null
    }
    return redirect(signInPageLink(redirectUrl))
  }

  if (res.status >= 400 && !request.url.includes(Links.signInPagePath)) {
    throw new Error("error while fetching app context")
  }

  let data = await res.json()
  return {
    environment: data.Environment,
    orgID: orgID === data.Organization.ID.toString() ? orgID : null,
    user: data.User,
    organization: data.Organization,
    csrfToken: data.CSRFToken,
    path: request.url,
    channels: [{ ID: 0, Name: "Uncategorized" }, ...data.Channels],
    campaigns: data.Campaigns ?? [],
    companyPages: data.CompanyPages ?? [],
    importSharesMaxImportCount: data.ImportSharesMaxImportCount,
    importSharesMaxAgeDays: data.ImportSharesMaxAgeDays,
    organizations: data.Organizations ?? []
  }
}

export async function loadSignInPageData({ request }) {
  const url = new URL(request.url)
  const redirectURL = url.searchParams.get("redirect")
  const otpPendingEmail = url.searchParams.get("otp-pending")
  return { redirectURL, otpPendingEmail }
}
